import { FelaCSS, colors, spacing } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  carousel: FelaCSS;
  gallery: FelaCSS;
  galleryItem: FelaCSS;
  viewAll: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    flex: 1,
    gap: spacing[4],
    flexDirection: 'row',
  },
  carousel: {
    cursor: 'pointer',
    maxWidth: 533,
    maxHeight: 399,
    overflow: 'hidden',
    flex: 1,
    borderRadius: spacing[2],
    position: 'relative',

    maxWidthTablet: {
      maxWidth: 'initial',
      maxHeight: 'initial',
    },

    maxWidthTabletSm: {
      borderRadius: 0,
    },
  },
  gallery: {
    display: 'grid',
    position: 'relative',
    gridTemplateColumns: 'repeat(2, 235px)',
    gridTemplateRows: 'repeat(2, 193px)',
    rowGap: 12.5,
    columnGap: spacing[4],
    marginLeft: 'auto',
    cursor: 'pointer',
  },
  galleryItem: {
    borderRadius: spacing[2],
    overflow: 'hidden',
  },
  viewAll: {
    position: 'absolute',
    right: 44.5,
    bottom: 12.5,
    padding: `${spacing[4]} ${spacing[5]}`,
    gap: spacing[2],
    color: colors.space,
    fontDefault: 15,
    flexDirection: 'row',
    alignItems: 'center',
    background: colors.white,
    borderRadius: 100,
    lineHeight: spacing[4],
    border: '1px solid rgba(26, 44, 64, 0.1)',

    maxWidthTabletSm: {
      right: spacing[4],
      bottom: spacing[4],
      padding: `${spacing[2]} ${spacing[3]}`,
    },
  },
});

export default styles;
